'use client';
import { PageLayout } from '@xtnd/web/shared/layout';
import { MatterArDetailProvider } from '../components/common';
import LedgerReportForm from '../components/reports/LedgerReportForm';

export default function LedgerReportsPage() {
  return (
    <PageLayout
      title="Ledger Reports"
      description="Generate and view ledger reports."
    >
      <MatterArDetailProvider>
        <LedgerReportForm />
      </MatterArDetailProvider>
    </PageLayout>
  );
}
